import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { InboxSettingsService } from '@app/shared/services/settings/inbox-settings/inbox-settings.service';
import { UserService } from '@app/shared/services/user/user.service';
import * as loginSelectors from './../../../../../root-store/login-store/login.selector';
import { Store } from '@ngrx/store';
import * as fileSaver from 'file-saver';
import { Subscription } from 'rxjs';

import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'discovery-download',
  templateUrl: './download.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DiscoveryDownloadComponent implements OnInit, OnDestroy {
  @Input() data;
  @Input() innerContent;
  @Output() previousNextDownloadEventEmitter = new EventEmitter<any>();

  currentUser;
  subscription = new Subscription();

  constructor(private store: Store, private _userService: UserService, private _inboxService: InboxSettingsService) {
    this.subscription.add(
      this.store.select(loginSelectors.getCurrentUserDetailsAll).subscribe((user) => {
        this.currentUser = user;
      })
    );
  }
  ngOnInit(): void {}

  getDownloadURLForOnboardingCheckList() {
    this.subscription.add(
      this._userService.getDownloadURLForOnboardingCheckList(this.innerContent?.downloadType, this.data?.user_discovery_path_id).subscribe(
        (res) => {
          this.subscription.add(
            this._inboxService.downloadBlob(res?.url).subscribe(
              (result) => {
                fileSaver.saveAs(result, res?.name);
              },
              (error: any) => {}
            )
          );
        },
        (error: any) => {}
      )
    );
  }

  handleSteps(event) {
    this.previousNextDownloadEventEmitter.emit({ status: event, id: this.data?.id });
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }
}
